import { IDayReport } from 'common/interfaces/iDayReports';
import { formatDateTime, getDisplayDate, getDisplayDateWithTime } from './date-util';
import { DATE_FORMATS } from 'common/constants';
import { IDayReportField } from 'common/interfaces';
import { IRoyaltyReport } from 'common/interfaces/iRoyaltyReports';

export const getDayReportTitle = (report?: IDayReport | null | undefined, useTimings?: boolean) => {
  if (!report) {
    return '';
  }

  return 'Day Report' + '  #' + '.v' + report?.version;
};

export const getDayReportDisplayDate = (
  item: IDayReport | null | undefined,
  format: string = DATE_FORMATS.YYYYMMDD_HHmmss,
) => {
  if (!item) {
    return '';
  }
  return formatDateTime(new Date(item.reportDate), format);
};

export const getDayReportUpdateDate = (item: IDayReport | null | undefined, withTime?: boolean) => {
  if (!item || (!item.updatedTime && !item.createdTime)) {
    return '';
  }
  return withTime
    ? getDisplayDateWithTime(item.updatedTime || item.createdTime)
    : getDisplayDate(item.updatedTime || item.createdTime);
};

export const getRoyaltyReportUpdateDate = (item: IRoyaltyReport | null | undefined, withTime?: boolean) => {
  if (!item || (!item.updatedTime && !item.createdTime)) {
    return '';
  }
  return withTime
    ? getDisplayDateWithTime(item.updatedTime || item.createdTime)
    : getDisplayDate(item.updatedTime || item.createdTime);
};

export const convertToFieldNameMetaMap = (salesFields: IDayReportField[]) => {
  return salesFields.reduce(
    (acc, field) => {
      acc[field.fieldName.toLowerCase()] = field;
      return acc;
    },
    {} as { [itemCode: string]: IDayReportField },
  );
};
